import { List }                                 from 'immutable';
import PropTypes                                from 'prop-types';
import { connect }                              from 'react-redux';
import {
  setDisplayName,
  setPropTypes
}                                               from 'recompose';
import {
  MAP_RESOURCE_DATA_PROP_RESOURCE_DATA,
  MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM,
  MAP_RESOURCE_PROP_RESOURCE_ID
} from './mapResourceProps.const';
import { MapResourceItemApiUrlFromIdPropTypes } from './mapResourceItemApiUrlFromId';
import { createSelectResourceAllItemById }      from '../../selectors/resourceSelectors';


/**
 * HOC to map the 'resources' props from state, for collections of resources.
 *
 * This can be coupled with the following components to chain props up and down stream…
 *
 *    mapResourceCollectionApiUrl(
 *        mapLoadResources()
 *    )
 *
 * @param {string}  resourceName Name of the resource.
 * @param {?string} remapToProp  If provided, will remap resourceItem to this prop name, and remove resourceItem/Data
 *                               props
 *
 * @return {function(*=): (ComponentClass<Omit<TInjectedProps, keyof {resourceItem: *, resourceData: *} & {}> &
 *   {resourceName: *, apiUrl: *}> & {WrappedComponent: Component<TInjectedProps>})}
 */
const mapResourceItemById = ({resourceName, remapToProp = null}) => (Component) => {

  const makeMapState = () => {

    const selectResourceAllItemById = createSelectResourceAllItemById(resourceName);

    return (state, {[MAP_RESOURCE_PROP_RESOURCE_ID]: resourceId}) => {

      const data = selectResourceAllItemById(state, {resourceId});

      if (remapToProp) {

        return {[remapToProp]: data};

      }

      return {
        [MAP_RESOURCE_DATA_PROP_RESOURCE_DATA]: data,
        [MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM]: data
      };

    };

  };

  return setDisplayName('MapResourceItemByIdUrl')(
    setPropTypes({

      ...MapResourceItemApiUrlFromIdPropTypes,

    })(
      connect(makeMapState, {})(Component)
    )
  );

};


export const MapResourceItemByIdUrlPropTypes = {

  // Collection of resources.
  [MAP_RESOURCE_DATA_PROP_RESOURCE_DATA]: PropTypes.instanceOf(List),

  // Same as resourceCollection, but using a name that's common to collection & item data.
  [MAP_RESOURCE_DATA_PROP_RESOURCE_ITEM]: PropTypes.instanceOf(List),

};


export default mapResourceItemById;


// WEBPACK FOOTER //
// ./src/components/resources/mapResourceItemById.js